<template>
  <default-layout>
     <v-layout wrap>
         <v-flex xs12>
             <ticket-menu-bar></ticket-menu-bar>
         </v-flex>

         <v-flex xs12 class="pt-5">
             <vip-sonko-ticket-table></vip-sonko-ticket-table>
         </v-flex>

         <v-flex xs12 v-if="tickets" class="pt-5">
             <vip-sonko-ticket-table :tickets="tickets"></vip-sonko-ticket-table>
         </v-flex>
     </v-layout>
  </default-layout>
</template>
<script>
import TicketMenuBar from './_components/ticket_menu.vue'
import VipSonkoTicketTable from './_components/vip_sonko_ticket_table.vue'

export default {
  name: 'TicketIndexPage',
  components: {
    TicketMenuBar,
    VipSonkoTicketTable
  },
  data () {
    return {
      tickets: null,
      currentPage: typeof this.$route.query.page != "undefined" ? this.$route.query.page : 1,
      amount: 0,
      pagination: {rowsPerPage: 12,page: 1},
    }
  },
  methods: {
   
  },
}
</script>
